module.exports = __webpack_public_path__ + "img/gift-card.19dc11c7.svg";